import React, { useEffect, useState } from "react";
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Form,
  Input,
  Label,
} from "reactstrap";
import Breadcrumb from "components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import axios from "axios";
import Select from "react-select";

import ReactSelect from "react-select";

import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import Pagi2 from "common/utils/Pagi2";
import viewTaskImg from "../../assets/images/viewTask.jpg";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import Swal from "sweetalert2";

function TableContainer({ columns, data }) {
  const [fixedContent, setFixedContent] = useState(false);

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);

  const [name_modal, setNameModal] = useState(false);
  const [title, setTitle] = useState("");

  const info = [
    {
      title: "Assigned",
      mean: " <p> <strong>Meaning :</strong> In the Mars System's Lead Module, the <strong>Assigned </strong> column designates the specific team member or individual responsible for overseeing and taking action on a lead or potential business opportunity. </p>",
      purpose:
        " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong> column in the Lead Module is to assign clear accountability for each lead. By identifying who is responsible for nurturing and converting leads into customers, it streamlines lead management, ensures follow-up, and enhances the chances of successful lead conversion. This fosters a more efficient and organized approach to lead handling within the Mars System.</p>",
    },
    {
      title: "Name",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Name</strong> column represents the name of the customer or organization for whom the proposal is being prepared.</p>",
      purpose:
        "<p> <strong>Purpose :</strong> The purpose of the <strong>Name</strong>  column is to provide specific identification of the recipient of the proposal. It ensures that each proposal is customized and addressed to the correct customer or organization, creating a personalized and professional impression. This column is crucial for accurate proposal documentation and effective communication within the Mars System, helping to build strong customer relationships and tailor proposals to individual needs.</p>",
    },
    {
      title: "Type",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Type</strong>  column categorizes proposals into distinct types, such as <strong>General</strong>, <strong>Website</strong>, <strong>SEO </strong>, <strong>Digital Marketing</strong>, or <strong>Dedicated Resource.</strong> </p>",
      purpose:
        "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Type</strong> column is to provide specific information about the person linked to the lead. It allows for personalized communication and relationship-building with leads. By knowing the names of potential clients or contacts, the Mars System's users can establish a more personal and targeted approach to lead engagement, which can significantly improve lead conversion rates and customer satisfaction</p>",
    },
    {
      title: "Currency",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the  <strong>Currency</strong> column specifies the currency in which the proposal's pricing and financial details are presented.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Currency</strong> column is to provide clarity and transparency regarding the currency in which the proposal's costs and pricing are expressed. This ensures that both your team and the client understand the financial terms of the proposal. By clearly indicating the currency, you facilitate accurate pricing and financial communication, especially in international or multi-currency transactions within the Mars System.</p>",
    },
    {
      title: "Price",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong>Price</strong> column denotes the total cost or pricing details associated with the proposal, which may include itemized costs for services, products, or any other expenses.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Price</strong>  column is to provide a clear and itemized breakdown of the costs associated with the proposal. It allows both your team and the client to understand the financial aspects of the proposal, making it easier to review and negotiate terms. This column ensures transparency in pricing and supports informed decision-making within the Mars System, helping to reach agreements that align with both parties' expectations.</p>",
    },
    {
      title: "Created At",
      mean: " <p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Created At</strong> column records the date and time when the proposal was initially created or entered into the system.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Created At</strong> column is to track and document the proposal's creation timeline. It provides valuable information about the proposal's age and origin, allowing users to gauge its recency and relevance. This column aids in organizing proposals chronologically, assessing the efficiency of the proposal creation process, and ensuring that proposals are up-to-date and timely managed within the Mars System.</p>",
    },
    {
      title: "Open Till",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong> Open Till</strong>column signifies the date until which the proposal remains valid and open for consideration by the client.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong> Open Till</strong> column is to establish a clear expiration date for the proposal's validity. It ensures that both your team and the client are aware of the timeframe within which the proposal can be accepted or negotiated. This column helps manage proposal timelines, avoid misunderstandings, and maintain accurate records of proposal status within the Mars System.</p>",
    },
    {
      title: "Status",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong>Status</strong> column categorizes proposals into different stages, including <strong>In Progress </strong>, <strong>On Hold </strong>, <strong>Lost </strong>, or <strong>Won </strong>.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong>Status</strong> column is to provide a quick overview of the current state of each proposal. It helps users track and manage the progression of proposals, from creation to closure. By categorizing proposals into these stages, the Mars System facilitates efficient proposal management, allowing teams to focus their efforts on active proposals, prioritize follow-ups, and accurately report on the status of each proposal. This column aids in effective decision-making and resource allocation.</p>",
    },
  ];

  const [viewData, setViewData] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [currency_data, setCurencyData] = useState([]);

  // Render the UI for your table
  return (
    <div>
      <Row>
        <div className="col-md-12 mb-4 d-flex">
          <div className="col-md-3 d-flex justify-content-start align-items-center">
            <select
              className="s me-4 form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-9 d-flex justify-content-end align-items-center">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <div className="position-relative">
        <CommonTableContainer columns={columns} data={data} status={true} />
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-space-between align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  );
}

const ViewTasks = ({ data }) => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [formRows, setFormRows] = useState([{}]);
  const inpRow = [{ name: "", file: "" }];
  const [inputFields, setinputFields] = useState(inpRow);

  function handleAddFields() {
    const item1 = { name: "", file: "" };
    setinputFields([...inputFields, item1]);
  }

  const onAddFormRow = () => {
    setFormRows([...formRows, {}]);
  };

  const onDeleteFormRow = (index) => {
    const newInputs = [...formRows];
    newInputs.splice(index, 1);
    setFormRows(newInputs);
  };

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setmodal_fullscreen(false);
  });

  //meta title
  document.title = "Projects | Zithas Technologies";

  const [viewTaskHistory, setViewTaskHistory] = useState(false);
  const [viewTask, setViewTask] = useState(false);
  const [viewTaskdata, setViewTaskdata] = useState({});
  const [timerStatus, setTimerStatus] = useState(true);

  const SelectStatus = [
    { label: "Pending", value: "0" },
    { label: "In Progress", value: "1" },
    { label: "Dev complete", value: "2" },
    { label: "Understanding", value: "3" },
    { label: "Awaiting Clients' Feedback", value: "5" },
  ]
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "task_id",
        title: "ID",
        isInfoIcon: false,
        className: "text-center task_id",
      },

      {
        Header: "Task Name",
        title: "Task Name",
        accessor: (row) => row["taskDetails.title"],
        isInfoIcon: false,
        className: "task_name_box",
      },
      // {
      //   Header: "Milestone",
      //   title: "Milestone",
      //   accessor: "milestone",
      //   isInfoIcon: false,
      //   className: "milestone_box text-center",
      // },

      {
        Header: "Status",
        title: "Status",
        accessor: (row) => row["taskDetails.status"], // This is good
        id: "taskDetails.status", // Needed for sorting/filtering
        isInfoIcon: false,
        className: "status_box text-centers",
        Cell: (cellProps) => {
          const status = cellProps.value; // This gives the result of the accessor
          const statusLabel =
            SelectStatus?.find((item) => item?.value == status)?.label || "-";
          return <div className="text-dark">{statusLabel}</div>;
        },
      },

      // {
      //   Header: "Time Taken",
      //   title: "Last Updated Days",
      //   accessor: "total_time_taken",
      //   isInfoIcon: false,
      //   className: "days_box text-center",
      // },

      {
        Header: "Action",
        accessor: "action",
        className: "task_action text-center",
        Cell: (cellProps) => {
          return (
            <div className="d-flex justify-content-center">
              {/* <a
                className="btn btn-sm btn-outline-success me-1"
                title="Start / Stop Timer"
                onClick={()=> onTimerStart()}
              >
                <i className="fa fa-stopwatch"></i>
              </a>

              <a
                // onClick={()=> setEditTask(true)}
                className="btn btn-sm btn-outline-secondary me-1"
                title="Task History"
                onClick={() => setViewTaskHistory(true)}
              >
                <i className="fas fa-eye "></i>
              </a> */}
              <a
                className="btn btn-sm btn-outline-secondary me-1"
                title="View Task"
                onClick={() => {
                  setViewTask(true);
                  setViewTaskdata(cellProps.row.original);
                }}
              >
                <i className="fas fa-info"></i>
              </a>
            </div>
          );
        },
      },
    ],
    []
  );

  // const data = [
  //   {
  //     sr_no: "1",
  //     task_name: "Createing Introducer portals design with view popup. and also create project sections view popup.",
  //     status_col: "In Progress",
  //     days_col: "2 days 04:45",
  //   },
  //   {
  //     sr_no: "2",
  //     task_name: "Createing Introducer portals design with view popup. and also create project sections view popup.",
  //     status_col: "In Progress",
  //     days_col: "2 days 04:45",
  //   },
  //   {
  //     sr_no: "3",
  //     task_name: "Createing Introducer portals design with view popup. and also create project sections view popup.",
  //     status_col: "Not Started",
  //     days_col: "2 days 04:45",
  //   },
  //   {
  //     sr_no: "4",
  //     task_name: "Createing Introducer portals design with view popup. and also create project sections view popup.",
  //     status_col: "In Progress",
  //     days_col: "2 days 04:45",
  //   },
  //   {
  //     sr_no: "5",
  //     task_name: "Createing Introducer portals design with view popup. and also create project sections view popup.",
  //     status_col: "Not Started",
  //     days_col: "2 days 04:45",
  //   },

  // ]

  return (
    <React.Fragment>
      <div className="">
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer columns={columns} data={data} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Task History  */}
      <div
        className={`note-sticky-form ${viewTaskHistory ? "d-block" : "d-none"}`}
      >
        <Draggable>
          <ResizableBox
            width={1000}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">View Task History</h5>
              <button
                type="button"
                onClick={() => {
                  setViewTaskHistory(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <div className="modal-body pe-4 my-5">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
                  <div className="text-center">
                    <img
                      src={viewTaskImg}
                      alt="Addepe"
                      style={{ width: "80%" }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <Table bordered hover responsive size="" striped>
                    <thead>
                      <tr>
                        <th className="text-center task-col-1">ID</th>
                        <th className="task-col-2 text-center">Start Date</th>
                        <th className="task-col-2 text-center">Start Time</th>
                        <th className="task-col-3 text-center">End Date</th>
                        <th className="task-col-3 text-center">End Time</th>
                        <th className="task-col-4 text-center">Total Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td scope="row" className="text-center task-col-1">
                          1
                        </td>
                        <td className="task-col-2 text-center">06-08-2024</td>
                        <td className="task-col-2 text-center">10:00:00</td>
                        <td className="task-col-3 text-center">07-08-2024</td>
                        <td className="task-col-4 text-center">11:40:30</td>
                        <td className="text-center task-col-5">08:40:30</td>
                      </tr>
                      <tr>
                        <td scope="row" className="text-center task-col-1">
                          2
                        </td>
                        <td className="task-col-2 text-center">06-08-2024</td>
                        <td className="task-col-2 text-center">10:00:00</td>
                        <td className="task-col-3 text-center">07-08-2024</td>
                        <td className="task-col-4 text-center">11:40:30</td>
                        <td className="text-center task-col-5">08:40:30</td>
                      </tr>
                      <tr>
                        <td scope="row" className="text-center task-col-1">
                          3
                        </td>
                        <td className="task-col-2 text-center">06-08-2024</td>
                        <td className="task-col-2 text-center">10:00:00</td>
                        <td className="task-col-3 text-center">07-08-2024</td>
                        <td className="task-col-4 text-center">11:40:30</td>
                        <td className="text-center task-col-5">08:40:30</td>
                      </tr>
                      <tr>
                        <td scope="row" className="text-center task-col-1">
                          4
                        </td>
                        <td className="task-col-2 text-center">06-08-2024</td>
                        <td className="task-col-2 text-center">10:00:00</td>
                        <td className="task-col-3 text-center">07-08-2024</td>
                        <td className="task-col-4 text-center">11:40:30</td>
                        <td className="text-center task-col-5">08:40:30</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* View Task Detaisl  */}
      <div className={`note-sticky-form ${viewTask ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={1000}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">View Task Details</h5>
              <button
                type="button"
                onClick={() => {
                  setViewTask(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <div className="modal-body pe-4">
              <Form className="row d-flex justify-content-center align-items-center">
                <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
                  <div className="text-center">
                    <img
                      src={viewTaskImg}
                      alt="Addepe"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="col-md-8 d-flex flex-column new-task-modal ">
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-md-12  ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Title <span className="text-danger">*</span>
                      </Label>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <input
                          disabled
                          type="text"
                          className="form-control"
                          placeholder="Enter Title"
                          value={viewTaskdata?.["taskDetails.title"]}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Milestone <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        value={`MileStone ${viewTaskdata?.milestone}`}
                      />
                    </div>
                    <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Priority <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        value={viewTaskdata?.["taskDetails.priority"]}
                      />
                    </div>
                    {/* <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Estimation Hours <span className="text-danger">*</span>
                      </Label>
                      <Select
                        isDisabled="true"
                        placeholder="Select Estimate time"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={Estimation_Hours}
                      />
                    </div> */}
                  </div>

                  {/* <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Probability (%) <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Enter Probability in (%)"
                      />
                    </div>
                    <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Priority <span className="text-danger">*</span>
                      </Label>
                      <Select
                        isDisabled="true"
                        placeholder="Select Priority"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={Priority}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-12 ps-2 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                    <div className="col-12">
                      <label htmlFor="">Description</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        cols="50"
                        disabled
                        value={viewTaskdata?.["taskDetails.description"]?.replace(
                          /<[^>]+>/g,
                          ""
                        )}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  );
};

export default ViewTasks;
